import { Vue, Ref, Prop, Component } from 'vue-property-decorator'

@Component({
})
export default class AssignmentsModal extends Vue {
    @Ref() readonly assignmentsModal!: any

    @Prop(String) readonly actionTitle!: string

    show() {
        this.assignmentsModal.show()
    }

    hide() {
        this.assignmentsModal.hide()
    }
}
